import { lazy } from "react";
import { Applications as ApplicationsIcon } from "@volt_developers/react-ui-components";
import { Route } from "../RouteModel";

const ApplicationList = lazy(
  () => import("./../../pages/configuration/applications/List")
);
const ApplicationDetails = lazy(
  () => import("./../../pages/configuration/applications/Details")
);
const ApplicationNotificationsSettingsConfigure = lazy(
  () =>
    import(
      "./../../pages/configuration/applications/NotificationsSettingsConfigure"
    )
);

export const applicationChildRoutes: Route[] = [
  {
    i18nName: "Configure notifications",
    path: "/configuration/applications/:id/notifications/settings",
    component: ApplicationNotificationsSettingsConfigure,
    can: {
      do: "update",
      on: "client",
    },
  },
  {
    i18nName: "Application",
    path: "/configuration/applications/:id",
    component: ApplicationDetails,
    newTheme: true,
    can: {
      do: "details",
      on: "client",
    },
  },
];

export const applicationRoutes: Route = {
  path: "/configuration/applications",
  i18nName: "Applications",
  icon: ApplicationsIcon,
  component: ApplicationList,
  showChildrenInSidebar: false,
  hasNestedSwitch: true,
  newTheme: true,
  can: {
    do: "list",
    on: "client",
  },
};
